import gql from "graphql-tag";

export default gql`
	mutation requestTrial($email: String!) {
		requestTrial(email: $email) {
			... on RequestTrialSuccess {
				trialId
				isAuthorized
				token
				refreshToken
			}
			... on RequestTrialFailure {
				errorCode
				message
			}
		}
	}
`;

export const readRequestTrialResult = ({ data }) =>
	data && {
		...data.requestTrial,
	};
